window.scrollToPlugin = require('gsap/all').ScrollToPlugin;
import { TweenMax, Power3 } from 'gsap/all';

const Helpers = {
    scrollTo(link, to, duration = 0.5) {
        // console.log(to);
        if (document.getElementById(to.substring(1)) === null) {
            document.cookie = "scroll=" + to;
            window.location.href = link;
            return;
        }

        return TweenMax.to(window, duration, { scrollTo: `${to}`, ease: Power3.easeInOut });
    },

    forEach(array, callback, scope, indexStart = 0) {
        for (var i = indexStart; i < array.length; i++) {
            callback.call(scope, i, array[i]); // passes back stuff we need
        }
    },

    getBoundingBox(svg) {
        if (svg.getBBox) {
            return svg.getBBox()
        } else if (svg.attributes.d) {
            let xmin, xmax, ymin, ymax
            let path = svg.attributes.d.value

            path = path.replace(/[a-z].*/g, ' ').replace(/[\sA-Z]+/gi, ' ').trim();

            const coordinate_list = path.split(' ');

            for (let coordinate of coordinate_list) {
                if (coordinate.length > 1) {
                    let initial_coordinate = coordinate.split(',');
                    xmin = xmax = initial_coordinate[0];
                    ymin = ymax = initial_coordinate[1];
                    break
                }
            }

            for (let coordinate of coordinate_list) {
                let xycoord = coordinate.split(',');
                if (!xycoord[1]) {
                    // ignore relative movements
                    xycoord[0] = xmin;
                    xycoord[1] = ymin;
                }
                xmin = Math.min(xmin, xycoord[0]);
                xmax = Math.max(xmax, xycoord[0]);
                ymin = Math.min(ymin, xycoord[1]);
                ymax = Math.max(ymax, xycoord[1]);
            }
            return [[xmin, ymax], [xmax, ymin]];
        }
    }
};

export default Helpers;
